/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Vimeo from '@u-wave/react-vimeo';
import {
  Video,
  CardVideo,
  TitleVideo,
  NumberVideos,
  CardCategory,
  LabelCategory,
  WrapperVideos,
  ContainerInput,
  ContainerLoader,
  ContainerVideos,
  PrincipalContainer,
  ContainerCategories,
  LabelSelectedCategory,
  HeaderSelectedCategory,
  ContainerSelectedCategory,
} from './styles'
import {
  Navbar,
  FluidContainer,
  InputComponent,
} from '../../components';
import {
  HowToVideos,
} from '../../utils/api';
import { Loader } from '../../components';
import { useInputValue } from '../../utils/hooks/useInputValue';

export default () => {
  const HowTo = new HowToVideos();

  const filterVideos = useInputValue('', 'search');
  const [isLoading, setLoader] = useState<Boolean>(true);
  const [selectedCategory, setSelectedCategory] = useState<Object>({});
  const [videoCategories, setVideoCategories] = useState<Array<Object>>([]);

  useEffect(() => {
    
    FetchHowToVideos()
  }, [])

  async function FetchHowToVideos(): Promise<void> {
    const response = await HowTo.GetHowToVideos();
    if (response.data.data.categories[0]) {
      setSelectedCategory(response.data.data.categories[0])
    }
    setVideoCategories(response.data.data.categories)
    setLoader(false)
  }

  return (
    <PrincipalContainer>
      <Navbar />
      <FluidContainer>
        <WrapperVideos>
          {isLoading ? (
            <ContainerLoader>
              <Loader height="90px" />
            </ContainerLoader>
          ) : (
            <>
              <ContainerCategories>
                {videoCategories?.map((category) => {
                  return (
                    <CardCategory key={'CC-' + category['_id']} onClick={() => setSelectedCategory(category)}>
                      <LabelCategory
                        isTitle={category['_id'] === selectedCategory['_id'] ? true : false}
                      >
                        {category['name']}
                      </LabelCategory>
                      <NumberVideos>{category['videos'].length} videos</NumberVideos>
                    </CardCategory>
                  )
                })}
              </ContainerCategories>
              <ContainerSelectedCategory>
                <HeaderSelectedCategory>
                  <LabelSelectedCategory>{selectedCategory['name']}</LabelSelectedCategory>
                  <ContainerInput>
                    <InputComponent
                      placeholder="Search a video"
                      dynamicSearch={filterVideos}
                    />
                  </ContainerInput>
                </HeaderSelectedCategory>
                <ContainerVideos>
                  {selectedCategory['videos'] && (
                    selectedCategory['videos']
                      .filter((video: any) => video.title.toLowerCase().includes(filterVideos.value.toLowerCase()))
                      .map((video: any) => (
                        <CardVideo key={`CV-${video['_id']}`}>
                          <Video>
                            <Vimeo
                              controls={true}
                              video={video.url}
                              responsive={true}
                            />
                          </Video>
                          <TitleVideo>{video.title}</TitleVideo>
                        </CardVideo>
                      ))
                  )}
                </ContainerVideos>
              </ContainerSelectedCategory>
            </>
          )}
        </WrapperVideos>
      </FluidContainer>
    </PrincipalContainer>
  );
};
